import { ProductDetailsMediaColor } from '../../../../services/modules/productDetails/productDetails.types';
import { ResolveMediaColorParams } from '../types/productDetailsMedias.types';

export const resolveMediaColor = ({
  colors,
  mediaProductColorId,
  gridProductColorId,
  detailsProductColorId,
}: ResolveMediaColorParams): ProductDetailsMediaColor | undefined => {
  const findColor = (id?: string): ProductDetailsMediaColor | undefined =>
    colors.find((color) => color.productColorId === id);

  return (
    findColor(mediaProductColorId) ??
    findColor(gridProductColorId) ??
    findColor(detailsProductColorId) ??
    colors.at(0)
  );
};
